export enum ROUTES {
  HOME = '/',
  BOARD = '/board/:group-slug/:page',
  GROUP = '/group/:group-slug',
  POST = '/news/:post-slug',
  COOKIE_DECLARATION = '/cookie-declaration',
  UTILS = '/utils',
}
